// extracted by mini-css-extract-plugin
export default {"Links":"LinksBanner_Links__j3K6R"};